import SmileDesignOrderDetails from "./SmileDesignOrderDetails";
import { SmileDesignCaseDetailsSectionV2 } from "../../Components/Order-Comps/SmileDesignCaseDetailsSectionV2";

function SmileDesignOrderDetailsV2(props) {
  return <SmileDesignOrderDetails {...props} CaseDetailsComponent={SmileDesignCaseDetailsSectionV2} />;
}

export default SmileDesignOrderDetailsV2;
